import { useAppSelector } from "@/lib/redux/hooks";
import HomeLinkComponent from "./HomeLink";
import { Container, Controls } from "./styles";
import UserPageComponent from "@/components/UserPage";

// Cast to fix React 17 + @types/react 18 compatibility issue
const HomeLink = HomeLinkComponent as any;
const UserPage = UserPageComponent as any;

const PrivateHeader: React.FC = () => {
  const desktopMenuIsOpen = useAppSelector((state) => state.desktopMenu.isOpen);

  return (
    <>
      <Container $desktopMenuIsOpen={desktopMenuIsOpen}>
        <HomeLink />
        <Controls>
          <UserPage />
        </Controls>
      </Container>
    </>
  );
};

export default PrivateHeader;
